import { produce } from 'immer';
import { AnyAction } from 'redux';

import { Action } from '../../../types';
import { GeoLocationState } from '../../../types/reducers';

import {
  SET_SELECTED_GEO_LOCATION,
  SelectedGeoLocationPayload,
} from '../../actions/GeoLocation';
import { AddressFull } from '../../../types/opzet';

/*
* A couple remarks here.
*
* The address has moved to a different location in the local storage.
* Though we still have to fetch the legacy location for backwards compatibility.
*
* Also we fallback on 'null' if there is no address in the local storage.
* Because we parse it as JSON that will result in an actuall null.
* That way we can properly type and use the value in logical operators.
*/
let legacyAddress = JSON.parse(localStorage.getItem('zcalendarAdresWidget-data') || 'null') as AddressFull | null;
const address = JSON.parse(localStorage.getItem('hvc-widgets-address') || 'null') as AddressFull | null;

// The legacy address in local storage can exist without data.
// We check for that here, if that's the case, reset the value in memory.
if (legacyAddress?.bagid === null) {
  legacyAddress = null;
}

const initialState: GeoLocationState = {
  selected: address || legacyAddress || null,
};

const immutableState = produce(initialState, (draftState) => draftState);

export default function geoLocationReducer(state = immutableState, action: AnyAction) {
  if (!action) return state;

  /* fired on init and checks whether the value of hvc-widgets-address and zcalendarAdresWidget-data are different
  *  if so this means the address has been changed in de afvalwegwijzer and should also be updated here
  */
  switch (action.type) {
    case 'REDUX_STORAGE_SAVE': {
      return produce(state, (draftState) => {
        if (legacyAddress?.bagid !== null && legacyAddress?.bagid !== address?.bagid) {
          draftState.selected = legacyAddress;
          localStorage.setItem('hvc-widgets-address', JSON.stringify(legacyAddress));
        }
      });
    }
    case SET_SELECTED_GEO_LOCATION: {
      return produce(state, (draftState) => {
        const typedAction = action as Action<SelectedGeoLocationPayload>;
        draftState.selected = typedAction.payload.data;

        if (typedAction.payload.data) {
          localStorage.setItem('zcalendarAdresWidget-data', JSON.stringify(typedAction.payload.data));
          localStorage.setItem('hvc-widgets-address', JSON.stringify(typedAction.payload.data));
        } else {
          localStorage.removeItem('zcalendarAdresWidget-data');
          localStorage.removeItem('hvc-widgets-address');
        }
      });
    }

    default:
      return state;
  }
}
